import {EventEmitter, Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ElementsService {

  formValidation = [];
  validatefail;
  validationResults = [];
  processedData = new Subject<any>();
  htmlData;
  selectedTableData = [];
  isSearchState = false;
  searchTermState = '';
  isSearchStateEmitter = new EventEmitter();

  paginationState: {

    currentPage: 0,
    listSize: 0,
    offset: 0,
    pageSize: 0,
    pageCount: 0,
    HTMLdata: [],
    RawHTMLdata : [],
    upper: 0
  }

  constructor() {
  }

  setValidation(id, validation) {

    if (validation != undefined) {
      this.formValidation.push({'id': id, 'validation': validation})
    }

  }

  isSearchEmitter(value: boolean){
    this.isSearchStateEmitter.emit(value);
  }

  getValidation(model) {

    this.validationResults = [];
    let modelVals = Object.values(model);

    this.formValidation.forEach((e, index) => {
      e.validation.map((v) => {
        this.validationResults.push({'id': e.id, 'validationFail': this.validate([v], modelVals[index])})
      })

    })
    //console.log(this.validationResults)

    return this.validationResults;

  }

  validate(validation, value) {

    if (validation !== undefined) {

      validation.map((e) => {

        this.validatefail = true;

        if (e.email) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          if (re.test(String(value).toLowerCase())) {
            this.validatefail = false;
          }
        }

        if ((typeof value === "string") && (e.minlength !== undefined)) {

          if (value.length >= e.minlength) {
            this.validatefail = false;
          }
        }

        if (e.check) {

          if (value == "on" || value == true) {
            this.validatefail = false;
          }
        }

      })

      return this.validatefail;

    }
  }

  setProcessedData(data) {
    this.processedData.next(data);
    return {
      unsubscribe() {
      }
    };
  }

  getProcessedData() {
    return this.processedData.asObservable();
  }

  setPaginationState(state) {
    this.paginationState = state;

  }

  getPaginationState() {
    return this.paginationState;
  }

  resetPaginationState(){
    this.paginationState = undefined;
  }
}
